/**
 * User: Faris
 * Date: 6/24/13
 * Time: 12:21 PM
 */

define('app/collections/Content_areas',['require','../models/Content_area'],function(require) {

  var Content_area = require('../models/Content_area');

  return Backbone.Collection.extend({

    model: Content_area

  });

});
